<template>
    <main
        class="bg-muted/40 text-foreground flex min-h-svh items-center justify-center px-4 py-12"
    >
        <div class="w-full max-w-md space-y-6">
            <div class="flex items-center justify-center gap-2.5">
                <span
                    class="bg-primary text-primary-foreground flex size-9 items-center justify-center rounded-lg"
                    ><Rocket class="size-5" aria-hidden="true" /></span
                ><span class="text-sm font-semibold"
                    >LaunchStation
                    <span class="text-muted-foreground">Org</span></span
                >
            </div>
            <Card
                ><CardContent class="p-6 sm:p-8"><slot /></CardContent
            ></Card>
            <p
                class="text-muted-foreground flex items-center justify-center gap-1.5 text-xs"
            >
                <ShieldCheck class="size-3.5" aria-hidden="true" />Internal
                staff access
            </p>
        </div>
    </main>
</template>
<script setup lang="ts">
import { Rocket, ShieldCheck } from '@lucide/vue';
import { Card, CardContent } from '@/components/ui/card';
</script>
